/**
 * DIOLYSH: instant cart-drawer close on product-link click (2026-07-21)
 *
 * Problem: clicking a product's image/title inside the open cart drawer
 * previously called the drawer's normal close() method, which plays a
 * ~0.4s slide-out + fade animation before the native <dialog> actually
 * closes. That animation keeps running while the browser has already
 * started navigating to the product page underneath it, so depending on
 * network/render timing the tab could show a half-closed drawer frozen
 * on screen for a moment before the new page paints — feeling "stuck".
 *
 * Fix: skip the animation entirely for this specific interaction. We
 * still clear the same [open] attribute and dispatch the same
 * `theme-drawer:close` event the normal close() does (so any state
 * persistence tied to that event/attribute still runs), but we close the
 * native <dialog> immediately instead of waiting on a CSS animation,
 * then hand off navigation ourselves. Since we're leaving the page
 * anyway, an exit animation has no payoff — instant is simply smoother.
 */
document.addEventListener(
  'click',
  (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const link = target.closest('a[data-cart-drawer-instant-close]');
    if (!link) return;

    const href = link.getAttribute('href');
    if (!href) return;

    const drawer = document.getElementById('cart-drawer');
    if (drawer) {
      event.preventDefault();

      drawer.removeAttribute('open');

      const dialog = drawer.querySelector('dialog');
      if (dialog) {
        dialog.classList.remove(
          'theme-drawer__dialog--opening',
          'theme-drawer__dialog--opening-inline-start',
          'theme-drawer__dialog--closing'
        );
        if (dialog.open) dialog.close();
      }

      drawer.dispatchEvent(new CustomEvent('theme-drawer:close', { bubbles: true }));

      window.location.href = href;
    }
  },
  { capture: true }
);
